import React from 'react'
import styled from '@emotion/styled';
import { PRINT_HOME_PAGE_URL_MWEB, PRINT_HOME_PAGE_URL_WEB } from 'constants/index';

interface IStyledContainer {
  theme: { [key: string]: any };
}

interface IComponentProps {
  printLayout?: boolean
  isWapView?: boolean
}

const Container = styled.section<IStyledContainer>`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 24px;
  font-weight:600;
  height: 90vh;
  text-align: center;
  padding:0 24px;
  img{
    width: 60px;
    margin: 0 0 20px
  }
  a{
    color: #E21B22;
  }
`

export const SomethingWentWrong = (props: IComponentProps) => {
  const { isWapView, printLayout } = props;
  if (printLayout) {
    return (
      <Container>
        <span><img src="https://static.toiimg.com/photo/98182157.cms" /></span>
        <div> Something went wrong. {' '}
          <a href={isWapView ? PRINT_HOME_PAGE_URL_MWEB : PRINT_HOME_PAGE_URL_WEB}> Click here</a> to
          browse TOI Print Edition</div>
      </Container>
    );
  }
  return (
    <Container>
      <span><img src="https://static.toiimg.com/photo/98182157.cms" /></span>
      <div> Something went wrong. Click {' '}
        <a href="https://timesofindia.indiatimes.com/toi-plus"> here</a> to
        browse TOI Plus Content</div>
    </Container>
  );
}

